










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ApexRadialChart extends Vue {
  @Prop({ default: () => 300 })
  private readonly height!: number;

  @Prop({ default: () => 0 })
  private readonly value!: number;

  @Prop()
  private readonly title!: string;

  @Prop({
    validator: (value: number) => {
      return value > 0 && value < 100;
    },
  })
  private readonly hollowSize!: number;

  private get series(): [number] {
    return [this.value];
  }

  private get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  private get textColor(): string {
    return this.isDark ? "#fff" : "#424242";
  }

  private get chartOptions() {
    return {
      chart: {
        type: "pie",
      },
      title: {
        text: this.title,
        align: "center",
        offsetY: 35,
        floating: true,
        style: {
          fontSize: "20px",
          color: "#fff",
        },
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: `${this.hollowSize}%`,
          },
          dataLabels: {
            name: {
              show: false,
              offsetY: -10,
              color: this.textColor,
            },
            value: {
              color: this.textColor,
              fontSize: "56px",
              show: true,
            },
          },
        },
      },
    };
  }
}
